import { connect } from 'react-redux';

import CartTrigger from '../components/CartTrigger';
import { toggleCartVisibility } from '../actions';

const mapStateToProps = state => {
  return {
    totalItems: state.lineItemsCount,
    isOpen: state.isOpen,
    hasViolation: state.currentOrder.violations.length > 0,
  };
};

const mapDispatchToProps = dispatch => ({
  toggleCartVisibility: () => dispatch(toggleCartVisibility()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CartTrigger);
